import { useEffect } from "react";

import { useTheme } from "@/components/admin/use-theme";

/** With theme "system" the page follows a scheme change live; the kit's ThemeProvider reads it only once. */
export const SystemThemeSync = () => {
  const { theme } = useTheme();
  useEffect(() => {
    if (theme !== "system") return;
    const root = window.document.documentElement;
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      root.classList.remove("light", "dark");
      root.classList.add(mql.matches ? "dark" : "light");
    };
    apply();
    mql.addEventListener("change", apply);
    return () => mql.removeEventListener("change", apply);
  }, [theme]);
  return null;
};
